import { PhylloGender } from '@round/api';

export type Gender = Lowercase<PhylloGender>;

export const GENDER_COLORS: Record<Gender, string> = {
    male: 'oklch(60.52% 0.1699 287.74)',
    female: 'oklch(75.51% 0.1452 165.37)',
    others: 'var(--chart-1)',
};

export const COUNTRY_COLOR = 'oklch(60.52% 0.1699 287.74)';
export const LANGUAGE_COLOR = 'oklch(75.51% 0.1452 165.37)';
